import React from 'react'
import { Link } from 'react-router-dom'

const HeaderReturnBooking = ({ title, state }) => {
    return (
        <div className='row'>
            <Link to='/client' className='text-decoration-none' style={{ color:'black', top: "0px", position: "fixed", width: "100%", backgroundColor:'white' }} state={{ uidClient:state.uidClient }}>
                <div className='row mt-2 pb-2 shadow bg-body' style={{ height:'4rem' }}>
                    <div className='col-1 text-start align-self-center'>
                        <span>
                            <i className="bi bi-arrow-left" style={{ fontSize:'1.8rem' }}></i>
                        </span> 
                    </div>
                    <div className='col text-start align-self-center'>
                        <span className='h5 text-center text-secondary'>{title}</span>
                    </div>
                </div>
            </Link>
        </div>
    )
}

export default HeaderReturnBooking